import React from 'react';
import { components, NoticeProps } from 'react-select';

export const AutocompleteNoOptionsMessage = (props: NoticeProps) => {
  return (
    <components.NoOptionsMessage {...props}>
      <p>No results</p>
    </components.NoOptionsMessage>
  );
};
